import { BoxWrapper } from "../Wrappers/Wrappers"
import { LgFileInput } from "../Form/FormInput"
import { LgFormInput } from "../Form/FormInput"
import { Text } from "../units/Text"
import { FlexWrapper } from "../Wrappers/Wrappers"
import { SubmitButton } from "../Buttons/buttons"
import { RestApiState } from "../Rest/Organization"
import { updateOsData, AcbOsPostProps } from "../Rest/RestAcbOs" 
import { useParams } from "react-router-dom"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { AcbOsProps, fetchOsData } from "../Rest/RestAcbOs"
import { useEffect, useState } from "react"


export interface OsFormProps {
    data: null | AcbOsProps;
    propSetter: (value: any) => void;
    newFile?: File;
    requestState: RestApiState;
    timeOutId: NodeJS.Timeout | null;
}

const defaultValue = {
        data : null,
        propSetter: (value: any) => {},
        newFile: undefined,
        requestState: RestApiState.Idle,
        timeOutId: null
    }



export const UpdateOs = ():JSX.Element => {
    const { user } = useSignedInContext()
    const { serial_number } = useParams()

    if (!serial_number) {
        throw new Error("serial number must be provided");
    }

    const [props, setProps] = useState<OsFormProps>(defaultValue)

    useEffect(() => {
        fetchOsData(serial_number, user.role_slug, (value:any) => {
            setProps(prev => ({
                ...prev, data: value
            }))
        });
    }, [])
    
    const valueSetter = (e: any) => {
        const { name, value } = e.target;
        setProps((prev) => ({
            ...prev, data: {
                ...prev.data, [name]:value
            }
        }))
    }

    const restStatusSetter = (value: RestApiState) => {
        setProps((prev:any) => ({
            ...prev, requestState: value}))
    }

    const fileChangeHandler = (e: any):void => {
        // TODO change all fileChangeHabdlers into one component
        var file = e.target.files[0]
        let success = true
        if (file) {
            const maxSize = 1000 * 1024;
            if (file.size > maxSize) {
                alert(`Допустимый размер менее ${maxSize}KB. ${file.size}`)
                success = false
            }


            if (!success) { 
                alert('Файл не соотвтесвует требованиям')
                file = undefined 
            }

            setProps((prev) => ({
                ...prev, newFile: file
                }))
        }
    }

    const handelSubmit = (e: any) => {
        e.preventDefault();
        if (props.newFile === undefined) {
            throw new Error("File cant be empty");
        };
        const dict: AcbOsPostProps = {file : props.newFile};
        restStatusSetter(RestApiState.Pending)
        updateOsData(serial_number, user.role_slug, dict, restStatusSetter);
    };

    return (
        <BoxWrapper bg="bg-primary" r="r10" p="p2">
            <Text size="xl" className="bold" >Обновление ОС для АКБ [{serial_number}]</Text>
            <form onSubmit={handelSubmit}>
                <FlexWrapper flexDirection="column" alignItems="start">
                    <LgFormInput 
                        value={props.data?.file_name ? props.data.file_name : 'Нет данных'} 
                        label='Название файла' 
                        name='file_name' 
                        type='text' 
                        required={false} 
                        valueSetter={valueSetter} 
                        disabled={true}
                    />
                    <LgFormInput 
                        value={props.data?.file_hash ? props.data.file_hash : 'Нет данных'} 
                        label='Хеш файла' 
                        name='file_hash' 
                        type='text' 
                        required={false} 
                        valueSetter={valueSetter} 
                        disabled={true}
                        className="flex-grow"
                    />
                    <LgFileInput 
                        value={props.newFile} 
                        label='Название файла' 
                        name='file_name'  
                        required={false} 
                        valueSetter={fileChangeHandler}
                        serverFile={props.data?.file_name ? props.data.file_name : ''}
                    />
                    <SubmitButton 
                        restState={props.requestState} 
                        disabled={ props.newFile === undefined } 
                        restHandler={{
                            timeOutId: props.timeOutId,
                            setter: (key: 'requestState' | 'timeOutId', value: any) => {
                                setProps((prev) => ({
                                    ...prev, [key]: value
                                }))
                            }
                        }}    
                    />
                </FlexWrapper>
            </form>
        </BoxWrapper>
    )
} 